import React, { useEffect, useState } from "react";

import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";

// redux
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import {
  resetFaqCard,
  updatingFaqCard,
} from "../../../../../redux/slices/cards/cardSlice";
import { toast } from "react-hot-toast";

import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import FAQForm from "../forms/FAQForm";

import useFetchBlock from "../../../../../hooks/useFetchBlock";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditFQS = () => {
  const { darkMode } = useSelector((state) => state.theme);

  const { translate } = useLocales();
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const { optionId } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  // data needed for calling fetching list
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = useState(false);

  const handleHeadingTextSubmit = async (data) => {
    data.optionId = optionId;
    data.language = prevData?.language;

    setSubLoader(true);

    await dispatch(updatingFaqCard(data)).then(() => {});

    setSubLoader(false);
    fetchingLinksList();
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };
  const {
    updatedFaqCard,
    updatedFaqCardError,
    updatedFaqCardSuccess,
    updatedFaqCardLoading,
    updatedFaqCardErrorMsg,
  } = useSelector((state) => state?.cards?.faqCard);
  useEffect(() => {
    if (updatedFaqCard?.status === "success" && updatedFaqCardSuccess) {
      toast.success(updatedFaqCard?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updatedFaqCard?.status === "failed" && updatedFaqCardSuccess) {
      toast.error(updatedFaqCard?.message);
    }
    if (updatedFaqCardError && updatedFaqCardErrorMsg) {
      toast.error(updatedFaqCardErrorMsg?.message);
    }
    dispatch(resetFaqCard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedFaqCard, updatedFaqCardLoading]);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      navigate("/500");
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={prevData?.language}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("faq")} </p>
          </div>
        </Link>
      </div>
      <FAQForm
        formType={"edit"}
        submitHandlerParent={handleHeadingTextSubmit}
        handleDelete={() => setIsModalOpen(true)}
        isLoading={subLoader}
        preHeaderData={prevData}
      />
    </>
  );
};

export default EditFQS;
